import { render, staticRenderFns } from "./DataViewSidebar.vue?vue&type=template&id=5f54ee4b&scoped=true&"
import script from "./DataViewSidebar.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebar.vue?vue&type=style&index=0&id=5f54ee4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f54ee4b",
  null
  
)

export default component.exports